import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { RemoteDiagnosticsVddGenericStructure, SetNewValueObject } from '@vi-iot/client';
import { InputValuePipe } from '../../../../../../shared/pipes/input-value/input-value.pipe';

@Component({
  selector: 'app-vdd-ip-address-edit',
  templateUrl: './vdd-ip-address-edit.component.html',
  styleUrls: ['./vdd-ip-address-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddIpAddressEditComponent implements OnInit {
  @Input() structureArray: RemoteDiagnosticsVddGenericStructure[];
  @Output() setNewValue = new EventEmitter<SetNewValueObject>();
  value = '';

  constructor(private inputValuePipe: InputValuePipe) {}

  ngOnInit(): void {
    this.structureArray.forEach((structure, index) => {
      this.value +=
        index + 1 !== this.structureArray.length ? `${structure.value}.` : structure.value;
    });
  }

  valueChange(event: Event): void {
    const newValues = this.inputValuePipe.transform(event).split('.');
    this.structureArray.forEach((structure, index) => {
      this.setNewValue.emit({
        path: structure.path,
        newValue: newValues[index],
      });
    });
  }
}
